import React from "react";
import { classnames, ua } from '@weapp/utils';
import { iconClsPrefix } from "../../constants";
import Block from "../block";
import { IconProps, IconState, CustomIconComponentProps } from './types';
import { needSync, isEqual } from '../../utils/index';
import { ICON_MAP as IMG_ICON_MAP, ICON_NAMES_LOWER_MAP as IMG_ICON_NAMES_LOWER_MAP } from './map/img';
import { ICON_MAP as SPRITE_ICON_MAP, ICON_NAMES_LOWER_MAP as SPRITE_ICON_NAMES_LOWER_MAP } from './map/sprite';
import { createScriptUrlElements } from './utils';
import IconLoader from './utils/IconLoader';
// import loadIconChunk2 from './utils/IconLoader2';

const pngRegx = /-png$/;

class Icon extends React.PureComponent<IconProps, IconState> {

  constructor(props: IconProps) {
    super(props);
    this.state = {
      iconLoad: false,
      errorName: false
    }
  }

  componentDidMount() {
    // 渲染图标
    this.importReactIconCom();
  }

  componentDidUpdate(prevProps: IconProps, prevState: IconState) {
    // 需要触发 importReactIconCom 的情况
    // 1. icon name 变化
    // 2. icon style 变化
    // 4. icon size 变化
    // 5. icon moduleColor 变化
    // 6. icon title 变化
    // 7. icon spin 变化
    // 8. icon rotate 变化
    // 9. icon fill 变化
    // 10. icon url 变化
    const keys = ['name', 'style', 'color', 'size', 'spin', 'rotate', 'fill', 'url']
    if (this.shouldUploadSvgIcon(this.props, prevProps, keys)) {
      this.importReactIconCom();
    }
  }

  /**
   * 判断是否需要更新 svg icon
   * @param nextProps IconProps
   * @param prevProps IconProps
   * @param keys string[]
   * @returns boolean
   */
  shouldUploadSvgIcon = (nextProps: IconProps, prevProps: IconProps, keys: string[]) => {
    let shouldUpload = false;
    if (keys && keys.length > 0) {
      keys.forEach((key: any) => {
        if (!isEqual((nextProps as any)[key], (prevProps as any)[key])) {
          shouldUpload = true;
        }
      })
    }
    return shouldUpload;
  }
  /**************************************** 判断图标渲染方式（默认：0，svg：1） ****************************************/
  getIconRenderType = (iconName: string) => {
    const { customIconRenderType } = this.props;
    if (typeof customIconRenderType === 'function') {
      return customIconRenderType(iconName);
    } else {
      let browser = ua.browser;
      let version = ua.version.match(/(\d+)./)?.[1] || '';
      if (browser === 'IE') {
        return 1;
        // let IE_Error = ['Icon-Avatarman', 'Icon-Avatar', 'Icon-Avatarwomen', 'Icon-Document-attachment', 'Icon-exl', 'Icon-image', 'Icon-html', 'Icon-oct', 'Icon-other', 'Icon-pdf', 'Icon-ppt', 'Icon-video', 'Icon-txt', 'Icon-word', 'Icon-zip', 'Icon-ofd', 'Icon-Upload-file03', 'Icon-audio', 'Icon-exl01', 'Icon-Audio-files', 'Icon-Compressed-file', 'Icon-Excel-file', 'Icon-HTML-file', 'Icon-Installation-package-file', 'Icon-Ofd-file', 'Icon-PPT-file', 'Icon-Pdf-file', 'Icon-Picture-file', 'Icon-Txt-file', 'Icon-Unknown-file', 'Icon-Word-file', 'Icon-video-file', 'Icon-apk', 'Icon-apk02']
        // if (IE_Error.indexOf(iconName) !== -1) {
        //   return 1;
        // } else {
        //   return 0;
        // }
      } else if ((browser === 'Firefox' && version.toString() <= '65')) {
        let FireFox_Error = ['Icon-enclosure', 'Icon-Document-attachment', 'Icon-exl', 'Icon-image', 'Icon-html', 'Icon-oct', 'Icon-other', 'Icon-pdf', 'Icon-ppt', 'Icon-video', 'Icon-txt', 'Icon-word', 'Icon-zip', 'Icon-ofd', 'Icon-Upload-file03', 'Icon-audio', 'Icon-apk02', 'Icon-overtime', 'Icon-need-to-be-dealt-with', 'Icon-New-approval', 'Icon-handle02', 'Icon-Approval-process-settings', 'Icon-perator-settings', 'Icon-Node-settings', 'Icon-Attendance-track', 'Icon-Full-text-annotation', 'Icon-H5-Related-matters', 'Icon-H5-picture', 'Icon-H5-voice', 'Icon-Voice-to-text', 'Icon-at', 'Icon-enclosure', 'Icon-expression', 'Icon-Approval-colour', 'Icon-Approved-colour', 'Icon-Intelligent-instruction', 'Icon-Page-customization', 'Icon-Local-file-mcolor', 'Icon-System-file-mcolor', 'Icon-Outstanding-loans-mcolour', 'Icon-To-be-paid-mcolour', 'Icon-To-be-reimbursed-mcolour', 'Icon-Manual-input02', 'Icon-Check-input', 'Icon-Document-identification', 'Icon-My-invoice', 'Icon-My-email', 'Icon-Personal-approva-colour', 'Icon-return02', 'Icon-Desensitization-setting']
        if (FireFox_Error.indexOf(iconName) !== -1) {
          return 1;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
  }

  /**************************************** 获取图标 chunk 文件 ****************************************/

  /**
   * 加载 react icon component
   */
  importReactIconCom = async () => {
    const { name: nextName } = this.props;
    if (!nextName) return;
    this.setState({ iconLoad: false, errorName: false });

    const isSvg = this.getIconRenderType(nextName) === 1;
    if (isSvg) {
      IconLoader.getIconChunk(nextName, {
        bundleId: this.props.iconMapBundleid,
        path: this.props.iconMapPath,
        domain: this.props.iconResourceDomain
      }).then(svgContent => {
        // 成功获取到图标库对应的 image src
        let newState: any = {};
        newState.name = nextName;
        newState.svgContent = svgContent;
        newState.iconLoad = true;
        newState.type = "SVG";
        this.setState(newState);
      }).catch(() => {
        // 如果没有找到对应的文件，将 iconName 转为小写，进行一次匹配
        const lowerIconName = nextName.toLocaleLowerCase();
        if (IconLoader.getIconLowerKeysMap()?.[lowerIconName]) {
          const realName = IconLoader.getIconLowerKeysMap()?.[lowerIconName];
          IconLoader.getIconChunk(realName, {
            bundleId: this.props.iconMapBundleid,
            path: this.props.iconMapPath,
            domain: this.props.iconResourceDomain
          }).then(svgContent => {
            // 成功获取到图标库对应的 image src
            let newState: any = {};
            newState.name = realName;
            newState.svgContent = svgContent;
            newState.iconLoad = true;
            newState.type = "SVG";
            this.setState(newState);
          })
        }
      })
    } else {
      // 判断是 png 图标还是 svg 图标, png 图标以 -png 结尾
      if (pngRegx.test(nextName)) {
        // 加载 image 类型的 icon src
        IconLoader.loadImageIcon(nextName, {
          bundleId: this.props.iconMapBundleid,
          path: this.props.iconMapPath,
          domain: this.props.iconResourceDomain
        })
          .then(src => {
            // 成功获取到图标库对应的 image src
            let newState: any = {};
            newState.name = nextName;
            newState.src = src;
            newState.iconLoad = true;
            newState.type = "IMG";
            this.setState(newState);
          })
          .catch(err => {
            // 图标库中没有对应图标，尝试获取组件库图标
            this.getUiLibChunk(nextName);
          })
      } else {
        // 加载 svg 类型的 icon chunk 文件
        IconLoader.loadIconChunk(nextName, {
          bundleId: this.props.iconMapBundleid,
          path: this.props.iconMapPath,
          domain: this.props.iconResourceDomain
        })
          .then(() => {
            let newState: any = {};
            newState.name = nextName;
            newState.iconLoad = true;
            newState.type = "CHUNK";
            this.setState(newState);
          })
          .catch(() => {
            this.getUiLibChunk(nextName);
          })
      }
    }
  }

  /**
   * 加载组件库默认包含的图标
   * @param iconName string
   */
  getUiLibChunk = (iconName: string) => {
    const { rotate, style, color, fill, url, size, spin } = this.props;
    let pro, type: "IMG" | "CHUNK" | string = '';
    if (iconName in IMG_ICON_MAP) {
      pro = IMG_ICON_MAP[iconName];
      type = 'IMG';
    } else if (iconName in SPRITE_ICON_MAP) {
      pro = SPRITE_ICON_MAP[iconName];
      type = "CHUNK";
    }

    if (type) {
      // 异步挂载 svg
      pro?.()?.then((fn: any) => {
        if (type === 'CHUNK') {  // chunks
          try {
            // 判断图标是否已经加载过
            if (type === 'CHUNK' && IconLoader.checkIsIconLoaded(iconName)) {
              this.setState({ iconLoad: true, type: "CHUNK" })
              return;
            };
            // 处理获取 svg 的内容
            IconLoader.appendSymbolToRefs(iconName, fn.icons[iconName]);
            // 强制刷新组件
            this.setState({ iconLoad: true, type: "CHUNK" })
          } catch (err) {
            console.error(iconName)
            throw err;
          }
        } else if (type === 'IMG') {  // img
          let src = fn?.default;
          let newState: any = {};
          newState.name = iconName;
          newState.src = src;
          newState.iconLoad = true;
          newState.type = "IMG";
          this.setState(newState)
        } else if (fn?.default?.name === 'SvgCom') {  // react jsx icon 文件
          const svgStyle = rotate  // 图标旋转角度
            ? {
              color,
              ...style,
              msTransform: `rotate(${rotate}deg)`,  // 适配 ie 9
              transform: `rotate(${rotate}deg)`,
            }
            : { color, ...style };
          const svgClassString = classnames({
            [`${iconClsPrefix}-img`]: !!url,
            [`${iconClsPrefix}-${size}`]: true,
            [`${iconClsPrefix}-svg`]: true,
            [`${iconClsPrefix}-spin`]: !!spin,
            [`${iconName}`]: !!iconName,
            [`${this.props.fromIconfontCN?.fontName}`]: !!this.props.fromIconfontCN?.fontName
          });
          const innerSvgProps: CustomIconComponentProps = {
            className: svgClassString,
            style: svgStyle,
            fill: fill ? fill : 'currentColor',
          };
          let newState: any = {};
          newState.name = iconName;
          newState.content = React.createElement("svg", { ...innerSvgProps, }, fn.default());
          newState.iconLoad = true
          this.setState(newState)
        }
      })
        .catch(err => {
          console.error(err);
        })
    } else { // 如果没有找到对应的文件，将 iconName 转为小写，进行一次匹配
      const lowerIconName = iconName.toLocaleLowerCase();
      if (IconLoader.getIconLowerKeysMap()?.[lowerIconName]) {  // iconMap 中找到了对应内容
        const realName = IconLoader.getIconLowerKeysMap()?.[lowerIconName];
        if (pngRegx.test(lowerIconName)) {
          // 加载 image 类型的 icon src
          IconLoader.loadImageIcon(realName, {
            bundleId: this.props.iconMapBundleid,
            path: this.props.iconMapPath,
            domain: this.props.iconResourceDomain
          })
            .then(src => {
              // 成功获取到图标库对应的 image src
              let newState: any = {};
              newState.name = iconName;
              newState.src = src;
              newState.iconLoad = true;
              newState.errorName = true;
              newState.type = "IMG";
              this.setState(newState);
            })
        } else {
          const isIconLoaded = IconLoader.checkIsIconLoaded(iconName);
          if (isIconLoaded) {
            let newState: any = {};
            newState.name = iconName;
            newState.iconLoad = true;
            newState.errorName = true;
            newState.type = "CHUNK";
            this.setState(newState);
          } else {
            // 加载 svg 类型的 icon chunk 文件
            IconLoader.getIconChunk(realName, {
              bundleId: this.props.iconMapBundleid,
              path: this.props.iconMapPath,
              domain: this.props.iconResourceDomain
            })
              .then((svgContent) => {
                IconLoader.appendSymbolToRefs(iconName, svgContent, {
                  onSuccess: () => {
                    let newState: any = {};
                    newState.name = iconName;
                    newState.iconLoad = true;
                    newState.errorName = true;
                    newState.type = "CHUNK";
                    this.setState(newState);
                  }
                });
              })
          };
        }
      } else if (IMG_ICON_NAMES_LOWER_MAP[lowerIconName]) {  // png 中找到了对应内容
        const realName = IMG_ICON_NAMES_LOWER_MAP[lowerIconName];
        IMG_ICON_MAP[realName!]?.()?.then(fn => {
          let src = fn?.default;
          let newState: any = {};
          newState.name = iconName;
          newState.src = src;
          newState.iconLoad = true;
          newState.errorName = true;
          newState.type = "IMG";
          this.setState(newState)
        })
      } else if (SPRITE_ICON_NAMES_LOWER_MAP[lowerIconName]) {  // svg 中找到了对应内容
        const realName = SPRITE_ICON_NAMES_LOWER_MAP[lowerIconName];

        SPRITE_ICON_MAP[realName!]?.()?.then(fn => {
          try {
            // 判断图标是否已经加载过
            if (IconLoader.checkIsIconLoaded(iconName)) {
              this.setState({ iconLoad: true, errorName: true, type: "CHUNK" })
              return;
            }
            // 处理获取 svg 的内容
            IconLoader.appendSymbolToRefs(iconName, fn.icons[iconName]);
            // 强制刷新组件
            this.setState({ iconLoad: true, errorName: true, type: "CHUNK" })
          } catch (err) {
            console.error(iconName)
            throw err;
          }
        })
      }
    }
  }

  /**************************************** 图标渲染 ****************************************/

  /**
   * 渲染 自定义 svg 图标
   * @param Component React.ReactNode
   * @param innerSvgProps CustomIconComponentProps
   * @returns JSX.Element
   */
  renderInnerNode = (Component: React.ReactNode, innerSvgProps: CustomIconComponentProps) => {
    if (Component &&
      React.Children.count(Component) === 1 &&
      React.isValidElement(Component) &&
      React.Children.only(Component).type === 'svg') {
      let { children, ...resProps } = Component.props;
      return <svg  {...innerSvgProps} {...resProps} >
        {children}
      </svg>;
    } else if (
      React.Children.count(Component) === 1 &&
      React.isValidElement(Component) &&
      React.Children.only(Component).type === 'use') {
      return (
        <svg {...innerSvgProps} >
          {Component}
        </svg>
      );
    }

    return null;
  };

  /**
   * 渲染 IconFont 图标
   * @param props IconProps
   * @param innerSvgProps CustomIconComponentProps
   * @returns JSX.Element
   */
  renderIconFontNode = (props: IconProps, innerSvgProps: CustomIconComponentProps) => {
    const { fromIconfontCN: options } = props;

    /**
     * DOM API required.
     * Make sure in browser environment.
     * The Custom Icon will create a <script/>
     * that loads SVG symbols and insert the SVG Element into the document body.
     */
    if (
      options?.scriptUrl &&
      typeof document !== 'undefined' &&
      typeof window !== 'undefined' &&
      typeof document.createElement === 'function'
    ) {
      if (Array.isArray(options?.scriptUrl)) {
        // 因为iconfont资源会把svg插入before，所以前加载相同type会覆盖后加载，为了数组覆盖顺序，倒叙插入
        createScriptUrlElements(options?.scriptUrl.reverse());
      } else {
        createScriptUrlElements([options?.scriptUrl]);
      }
    }

    const { children } = props;

    let Component: React.ReactNode = null;
    if (options?.fontName) {
      Component = <use xlinkHref={`#${options?.fontName}`} />;
    }
    if (children) {
      Component = children;
    }

    if (Component &&
      React.Children.count(Component) === 1 &&
      React.isValidElement(Component) &&
      React.Children.only(Component).type === 'use') {
      return <svg  {...innerSvgProps}  >
        {Component}
      </svg>;
    }
  }

  /**************************************** render ****************************************/
  render() {
    const { className, wrapStyle, style, color, spin, rotate, onClick, fill, size, moduleColor,
      // SVG
      // custom SVG
      component: Component,
      // image
      url,

      customRender,
      children,
      title,
      id,
      name
    } = this.props;
    const { content: iconContent, src, iconLoad, errorName, type, svgContent } = this.state;

    //#region other icon
    const svgWrapper = classnames({
      [`${iconClsPrefix}`]: true,
      [`${iconClsPrefix}-wrapper`]: true,
      [`${iconClsPrefix}-${moduleColor}`]: typeof moduleColor !== 'undefined',
    }, className);

    const svgClassString = classnames({
      [`${iconClsPrefix}-img`]: !!url,
      [`${iconClsPrefix}-${size}`]: true,
      [`${iconClsPrefix}-svg`]: true,
      [`${iconClsPrefix}-spin`]: !!spin,
      [`${name}`]: !!name,
      [`${this.props.fromIconfontCN?.fontName}`]: !!this.props.fromIconfontCN?.fontName
    });

    const svgStyle = rotate  // 图标旋转角度
      ? {
        color,
        ...style,
        msTransform: `rotate(${rotate}deg)`,  // 适配 ie 9
        transform: `rotate(${rotate}deg)`,
      }
      : { color, ...style };

    const innerSvgProps: CustomIconComponentProps = {
      className: svgClassString,
      style: svgStyle,
      fill: fill ? fill : 'currentColor',
    };


    const innerImgProps = {
      className: svgClassString,
      style: svgStyle,
    }


    const spanProps = {
      onClick,
      className: svgWrapper,
      title,
      id,
      style: wrapStyle
    }

    // Custom content
    // let content = (
    //   <Block weId={`${this.props.weId || ''}_iydil5`} className={`${iconClsPrefix} icon-placeholer`} {...innerSvgProps} title={title}>
    //     {children}
    //   </Block>
    // );

    let content: any = (
      <span {...spanProps}>
        <div weId={`${this.props.weId || ''}_iydil5`} {...innerSvgProps} className={`${iconClsPrefix} icon-placeholer ${innerSvgProps.className}`} title={title}>
          {children}
        </div>
      </span>
    );

    // img Icon
    if (url) {
      content = (
        <span {...spanProps}>
          <img src={url} alt={url}  {...innerImgProps} />
        </span>
      );
    }

    // fontIcon.cn
    if (needSync('fromIconfontCN', this.props)) {
      content = (
        <span {...spanProps}>
          {this.renderIconFontNode(this.props, innerSvgProps)}
        </span>
      );
    }

    // custom SVG 
    if (Component) {
      content = (
        <span {...spanProps}>
          {this.renderInnerNode(this.props.component, innerSvgProps)}
        </span>
      );
    }

    //#endregion
    if (name && iconLoad) {
      // let type: string = '';
      // const lowerIconName = name.toLocaleLowerCase();
      // if (name in IconLoader.getIconMap()) {

      // }
      // // if (pngRegx.test(name) || name in IMG_ICON_MAP
      // //   || (errorName && lowerIconName in IMG_ICON_NAMES_LOWER_MAP)) {
      // //   type = 'IMG';
      // // } else if (name in IconLoader.getIconMap() || name in SPRITE_ICON_MAP
      // //   || (errorName && (lowerIconName in IconLoader.getIconLowerKeysMap() || lowerIconName in SPRITE_ICON_NAMES_LOWER_MAP))) {  // 本地组件库或者图标库
      // //   type = "CHUNK";
      // // }

      if (type === 'CHUNK') {
        // 使用 use 引用图标
        content = (
          <span {...spanProps}>
            <svg {...innerSvgProps} >
              <use xlinkHref={`#${this.props.name}`}></use>
            </svg>
          </span>
        )
      } else if (type === 'SVG' && svgContent) {
        content = (
          <span {...spanProps}>
            <svg {...innerSvgProps} dangerouslySetInnerHTML={{ __html: svgContent }} />
          </span>
        )
      } else if (type === 'IMG' && src) {
        content = (
          <span {...spanProps}>
            <img src={src} alt={name}  {...innerImgProps} />
          </span>
        )
      } else if (iconContent) {
        content = (
          <span {...spanProps}>
            {iconContent}
          </span>
        )
      }
    }
    return typeof customRender === 'function' ? customRender(this, content) : content;
  }
}

export default Icon;
